import { useCallback, useState } from "react";

function useForceRender() {
    const [, set] = useState(0)
    const updateState = useCallback(() => set(value => ++value), []);
    return updateState;
}
export default useForceRender;